import type { ActionTree, MutationTree } from 'vuex';
import type { ReviewState } from '~/types/store/review';
import type { RootState } from '~/types/store/index';

const getInitialState = (): ReviewState => ({
  user: {},
  testimonial: {},
});
export const state = getInitialState;

export const mutations: MutationTree<ReviewState> = {
  updateState(state, { user, testimonial }) {
    state.user = { ...state.user, ...(user || {}) };
    state.testimonial = { ...state.testimonial, ...(testimonial || {}) };
  },
};

export const actions: ActionTree<ReviewState, RootState> = {
  updateTestimonial({ commit }, { user, testimonial }) {
    commit('updateState', { user, testimonial });
  },
};
